import { ReferenceDetails } from "./reference-details";

export class ClientDetails {
    name!: string;
    phoneNumber!: string;
    age!: string;
    reference !: ReferenceDetails
}